'use strict';

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

module.exports = require('promise');


/*****************
 ** WEBPACK FOOTER
 ** ./~/fbjs/lib/Promise.js
 ** module id = 49
 ** module chunks = 0
 **/